
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div>
     <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <div class="border-raduis-md bg-white box-shadow-xl-dark mb-4 pl-5">
           <b-row align-v="center"  class="h-100">
             <b-col>
                <b-skeleton class="my-4" variant="light" height='30px' width="75%"></b-skeleton>
                <b-skeleton class="my-4" variant="light" height='30px' width="85%"></b-skeleton>
             </b-col>
             <b-col class="d-none d-lg-block">
               <b-skeleton-img variant="light" no-aspect height="305px"></b-skeleton-img>
             </b-col>
           </b-row>
        </div>
      </template>
      <div class="welcome border-raduis-md bg-white box-shadow-xl-dark mb-4 px-3">
        <div class="d-flex align-items-center h-100">
          <div class="pl-4">
            <h3 class="title">
              <span class="font-weight-bolder">{{ subTitle }}</span> !
            </h3>
          </div>
          <div v-if="image" class="d-none d-lg-block">
            <img
              :src="require(`@/assets/images/${image}`)"
              class="img-fluid"
              height="305"
              alt
            />
          </div>
        </div>
      </div>
     </b-skeleton-wrapper>

  </div>
</template>

<script>
export default {
  name: 'Welcome',
  props: ['firstName', 'lastName', 'subTitle', 'image','loading'],
};
</script>
